import { JSX } from "react";

interface IRowProps {
  children: string | JSX.Element | undefined;
  label: string;
  disableUpperCase?: boolean;
  breakWord?: boolean;
}

const Row = ({ children, label, disableUpperCase, breakWord }: IRowProps) => {
  return (
    <tr>
      <th className="grey withoutBold">{label}</th>
      <td
        className={`${breakWord ? "" : "wrapText"}`}
        style={{ whiteSpace: "break-spaces" }}
      >
        {children}
      </td>
    </tr>
  );
};

export { Row };
